import { queryOptions } from '@tanstack/react-query';

import { fetchClient } from '@/util/fetchClient';

export async function getTwilioTokenV2() {
  const { data } = await fetchClient.GET('/v2/twilio/token');

  return data?.data;
}

export function getTwilioTokenQueryOptionsV2(userId?: string) {
  return queryOptions({
    queryKey: ['twilioTokenV2', userId],
    queryFn: () => getTwilioTokenV2(),
    enabled: !!userId,
  });
}
